import { MAX_UPLOAD_MB } from "@/lib/fileLimit";

/** Small inline caption shown next to every uploader to advertise the limit. */
export function UploadLimitNote({ className = "" }) {
  return (
    <div className={`text-[11px] text-[#A09988] mt-1 ${className}`} data-testid="upload-limit-note">
      Dimensione massima: {MAX_UPLOAD_MB} MB per file
    </div>
  );
}
